import React from 'react';
import ComponentAlertRow from './ComponentAlertRow';
import StatusPill from '../../../shared/components/pill/StatusPill';

export default function ActiveAlertsCard({ alerts = [] }) {
  if (alerts.length === 0) return null;

  return (
    <div className="card mb-3">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="fw-bold mb-0">Active Alerts</h6>
          <StatusPill tone="danger" size="touch">
            {alerts.length} alert{alerts.length !== 1 && 's'}
          </StatusPill>
        </div>
        {alerts.map((alert, index) => (
          <ComponentAlertRow
            key={alert.id || index}
            alert={alert}
            severity="fault"
          />
        ))}
      </div>
    </div>
  );
}
